import { JSONData, Url } from 'sol-request-angular/dist/comunicacao';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ControlContainer, FormGroup } from '@angular/forms';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { distinctUntilChanged } from 'rxjs/operators';
import { DialogFactory } from 'sol-tools-ts/dist/dialog/dialog-factory';
import { environment } from "src/environments/environment";
import { FileUtils } from 'app/tools/file-utils';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';
import { AvatarCropperModalComponent } from 'app/shared/modal/avatar-cropper-modal/avatar-cropper-modal.component';
import { ModalService } from 'app/tools/modal/modal.service';
import { PessoaTipo } from '@tivic-team/manager-ts/dist/grl/enums/pessoa-tipo.enum';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';

@Component({
  selector: 'anexar-foto-motorista-auxiliar',
  templateUrl: './anexar-foto-motorista-auxiliar.component.html',
  styleUrls: ['./anexar-foto-motorista-auxiliar.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AnexarFotoMotoristaAuxiliarComponent implements OnInit {

  formGroup: FormGroup;
  nmArquivo: string;
  vlTamanhoArquivo: string;
  url: string;
  urlPreview: string;
  cdConcessionario: number;
  cdPessoa: number;
  tpConcessao: number;
  imagemCarregada: boolean = false;
  safeUrl: SafeUrl;

  constructor(
    public domSanitizer: DomSanitizer,
    private _controlContainer: ControlContainer,
    private _dialogFactory: DialogFactory,
    private _detector: ChangeDetectorRef,
    private _modalService: ModalService<AvatarCropperModalComponent>
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.getImage(0);
    this.formGroup.get('tpConcessao').valueChanges.pipe(distinctUntilChanged()).subscribe((tpConcessao) => {
      if(tpConcessao != null) 
        this.tpConcessao = tpConcessao;
    });
  }

  ngAfterViewInit(){
    this.formGroup.get('cdPessoa').valueChanges.pipe(distinctUntilChanged()).subscribe((cdPessoa) => {
      this.getImage(cdPessoa);    
    });
  }

  escolherFoto($event, file) {
    if(!this.formGroup.get('cdPessoa').value) {
      return this._dialogFactory.snack('Para enviar uma foto é necessário cadastrar o permissionário primeiro.');      
    }
    file.click();
  }

  public onFileChange(event) {
    const file = event.target.files[0];
    const allowedTypes = ['image/jpeg', 'image/png', 'image/jpg'];
    if (!allowedTypes.includes(file.type)) {
      return this._dialogFactory.snack('Tipo de arquivo não suportado. Selecione um arquivo JPG, JPEG ou PNG');
    }
    if ((file.size / 1024 / 1024) > 1) {
      return this._dialogFactory.snack('O tamanho do arquivo não pode ser superior a 1 MB');
    }
    this.selectImg(event);
  }

  public async selectImg(event) {
    this._modalService.component(AvatarCropperModalComponent).open(event);
    const subscription = this._modalService.onDismiss().subscribe(async base64 => {     
      if(base64 && base64.data) {
        const blob = await FileUtils.convertToBlob(base64.data, 'image/jpeg');
        this.urlPreview = URL.createObjectURL(blob);        
        this._detector.detectChanges();
        if(this.tpConcessao == ConcessaoTipo.TAXI) {
          this.formGroup.get('pessoaFisica').get('pessoa')
          .patchValue({imgFoto: base64.data.replace(/^[\w\d;:\/]+base64\,/g, '')});
        }
        else {
          this.formGroup
          .get(this.formGroup.value.gnPessoa === PessoaTipo.JURIDICA ? 'pessoaJuridica' : 'pessoaFisica')
          .get('pessoa')
          .patchValue({imgFoto: base64.data.replace(/^[\w\d;:\/]+base64\,/g, '')});
          
        }
      }
      this.atualizarImagemUrl();
      event.target.value = null;
      subscription.unsubscribe();
    });
  }

  private async getImage(cdPessoa: number) {
    this.url = new Url({
      id: 'mob/concessao/imagem/:cdPessoa',
      pathParams: new JSONData({ cdPessoa: cdPessoa }),
      environment: environment
    }).buildUrl();
    this.imagemCarregada = true;
    this.atualizarImagemUrl();
  }

  private atualizarImagemUrl() {
    const momento = new Date().getTime().toString();
    const urlComImagemAtualizada = this.urlPreview || this.url + '?' + momento;
    this.safeUrl = this.domSanitizer.bypassSecurityTrustUrl(urlComImagemAtualizada);
    this._detector.detectChanges();
  }
}
